import { Controller } from "@hotwired/stimulus"

/**
 * 通知設定コントローラー
 * 
 * グローバル通知設定（メール通知ON/OFF）の変更に応じて、
 * サーバー個別設定のチェックボックスを有効化/無効化します。
 * 
 * Validates: Requirements 5.3
 */
export default class extends Controller {
  static targets = ["globalCheckbox", "serverCheckbox", "warningMessage"]

  /**
   * コントローラー接続時に初期状態を設定
   */
  connect() {
    this.updateServerCheckboxes()
  }

  /**
   * グローバル通知設定の変更時にサーバー個別設定の状態を更新
   */
  toggleGlobal() {
    this.updateServerCheckboxes()
  }

  /**
   * サーバー個別設定のチェックボックスの有効/無効状態を更新
   */
  updateServerCheckboxes() {
    const globalEnabled = this.globalCheckboxTarget.checked

    // サーバー個別設定のチェックボックスを有効化/無効化
    this.serverCheckboxTargets.forEach((checkbox) => {
      checkbox.disabled = !globalEnabled
      
      // 親要素にも無効化状態を反映（スタイリング用）
      const toggleLabel = checkbox.closest(".settings-form__toggle")
      if (toggleLabel) {
        if (globalEnabled) {
          toggleLabel.classList.remove("settings-form__toggle--disabled")
        } else {
          toggleLabel.classList.add("settings-form__toggle--disabled")
        }
      }
    })

    // 警告メッセージの表示/非表示を切り替え
    if (this.hasWarningMessageTarget) {
      if (globalEnabled) {
        this.warningMessageTarget.classList.add("hidden")
      } else {
        this.warningMessageTarget.classList.remove("hidden")
      }
    }
  }
}
